import { FC } from "react";
import classNames from "classnames";

import { IButtonProps, TButtonType, TButtonSize } from "./types";

import styles from "./Button.module.css";

const mapTypeStyle: { [key in TButtonType]: string } = {
  ["fill-auth"]: styles["type-fill-auth"],
  ["fill-dark"]: styles["type-fill-dark"],
  ["fill"]: styles["type-fill"],
  ["outline"]: styles["type-outline"],
  ["outline-green"]: styles["type-outline-green"],
  ["outline-white"]: styles["type-outline-white"],
  ["empty"]: styles["type-empty"],
  ["round"]: styles["type-round"],
  ["round-outline"]: classNames(styles["type-round"], styles["type-round-outline"]),
  ["void"]: styles["type-void"],
};

const buttonSizeClassMap: { [key in TButtonSize]: string } = {
  sm: styles["size-sm"],
  md: styles["size-md"],
  lg: styles["size-lg"],
};

const Button: FC<IButtonProps> = ({
  className,
  size = "md",
  label,
  Icon,
  typeStyle = "fill",
  children,
  ...props
}) => {
  return (
    <button
      className={classNames(
        styles["button"],
        mapTypeStyle[typeStyle],
        buttonSizeClassMap[size],
        className
      )}
      {...props}
    >
      {Icon && <Icon />}
      {label && <span>{label}</span>}
      {children}
    </button>
  );
};

export default Button;
